(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ella-size-guide-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var tabs = root.querySelector('[data-ella-sg-tabs]');
      if (!tabs) return;
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ella-sg-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ella-sg-panel]'));
      if (buttons.length < 2 || panels.length < 2) return;

      tabs.hidden = false;

      function show(id) {
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-ella-sg-panel') !== id;
        });
        buttons.forEach(function (b) {
          b.setAttribute('aria-selected', b.getAttribute('data-ella-sg-tab') === id ? 'true' : 'false');
        });
      }

      buttons.forEach(function (b, i) {
        b.addEventListener('click', function () {
          show(b.getAttribute('data-ella-sg-tab'));
        });
        b.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = buttons[(i + 1) % buttons.length];
          if (e.key === 'ArrowLeft') next = buttons[(i - 1 + buttons.length) % buttons.length];
          if (next) {
            e.preventDefault();
            next.focus();
            show(next.getAttribute('data-ella-sg-tab'));
          }
        });
      });

      show(buttons[0].getAttribute('data-ella-sg-tab'));
    }

    function boot() {
      document.querySelectorAll('[data-ella-sg-charts]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
